
import { computed, watch, defineComponent, ref, Ref, ComputedRef } from "vue";
import FormInput from "./components/FormInput.vue";
import convert from "convert";

export default defineComponent({
  name: "App",
  components: { FormInput },
  setup() {
    const yearLight = 149600000;
    const thickness: Ref<number> = ref(80);
    const unit: Ref<"um" | "mm"> = ref("um");
    const foldingTimes: Ref<number> = ref(2);
    const distances = [
      { destination: "Moon", distance: 384400 },
      { destination: "Mars", distance: 78340000 },
      { destination: "Sun", distance: 147390321 },
      { destination: "Jupiter", distance: 628730000 },
      { destination: "Saturn", distance: 1275000000 },
      { destination: "Uranus", distance: 2723950000 },
      { destination: "Neptune", distance: 4351400000 },
    ];

    const sheetsCount: ComputedRef<number> = computed(() =>
      Array(foldingTimes.value)
        .fill(0)
        .reduce((acc) => acc * 2, 1)
    );

    // finalThickness variables
    const finalThicknessUnit = ref("");
    const finalThickness = ref(0);
    const finalThicknessKm = ref(0);

    watch([sheetsCount, thickness, unit], () => calcFinalThickness(), {
      immediate: true,
    });

    const reachedDistances = computed(() => {
      return distances.filter(
        (distance) => distance.distance <= finalThicknessKm.value
      );
    });

    function calcFinalThickness() {
      const totalThickness = sheetsCount.value * thickness.value;
      let result = totalThickness;

      if (unit.value == "um") {
        result = totalThickness / 1000;
      }

      result = +result.toFixed(2);

      finalThicknessKm.value = convert(result, "mm").to("km");

      const conversionResult: string = convert(result, "mm")
        .to("best", "metric")
        .toString();

      const conversionMatcher = conversionResult.match(/([\d.]+)(\w+)/);

      if (conversionMatcher && conversionMatcher.length === 3) {
        let conversionNumber = +conversionMatcher[1];
        let conversionUnit = conversionMatcher[2];

        // Bigger than AU (light year)
        if (conversionNumber > yearLight) {
          conversionUnit = "au";
          conversionNumber = conversionNumber / 149600000;
        }

        finalThicknessUnit.value = conversionUnit;
        finalThickness.value = conversionNumber;
      } else {
        finalThicknessUnit.value = "";
        finalThickness.value = 0;
      }
    }

    function formatNumber(value: number): string {
      return new Intl.NumberFormat(navigator.language, {
        maximumFractionDigits: 2,
      }).format(value);
    }

    return {
      thickness,
      unit,
      foldingTimes,
      finalThickness,
      finalThicknessUnit,
      finalThicknessKm,
      sheetsCount,
      formatNumber,
      reachedDistances,
    };
  },
});
